import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { UserPermissionGroupItemMaintenanceDto } from './UserPermissionGroupItemMaintenanceDto';
import { UserPermissionGroupListMaintenanceDto } from './UserPermissionGroupListMaintenanceDto';

@Injectable()
export class UserPermissionGroupSubMaintenanceController extends BaseSubMaintenanceController<UserPermissionGroupListMaintenanceDto, UserPermissionGroupItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/user/permissiongroup");
    }

    public getResourceRoot(): string {
        return "USER.PERMISSION.GROUP";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/securityandnotifications/user/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}